"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printCode = void 0;
const code_frame_1 = require("@babel/code-frame");
const jsonpos_1 = require("jsonpos");
function printCode(message, parsedJson, { dataPath, markIdentifier, linesAbove = 5, linesBelow = 3, }) {
    const { start, end } = jsonpos_1.getLocation(parsedJson, { dataPath, markIdentifier });
    if (!start)
        return `{The path ${dataPath} cannot be found in json}`;
    return code_frame_1.codeFrameColumns(parsedJson.jsonString, { start, end }, {
        highlightCode: true,
        message,
        linesAbove,
        linesBelow,
    });
}
exports.printCode = printCode;
